import { CheckSquareFilled, NumberOutlined } from '@ant-design/icons'
import { useMutationCheckMessage } from 'features/Invoice/screens/ListInvoice/queries'
import { IconAction } from 'general/components/GroupButton/styles'
import TableAction from 'general/components/GroupButton/TableAction'
import FindHistoryModal from 'general/components/Modal/FindHistoryModal'
import ModalUpdateNumberFormat from 'general/components/Modal/ModalUpdateNumberFormat'
import {
  INVOICE_CLASSIFY,
  INVOICE_STATUS,
  INVOICE_TYPE,
  SEND_TAX_STATUS,
  SUMMARY_INVOICE_STATUS,
} from 'general/constants/AppConstants'
import Utils from 'general/utils/Utils'
import { object } from 'prop-types'
import { useState } from 'react'
import ModalUpdateSendTaxStatus from '../ModalUpdateSendTaxStatus'

export const ActionsTable = ({
  row,
  setTvanState,
  setModalsState,
  refetchListInvoice,
}) => {
  // kém mã cho 1 hóa đơn
  const { mutate: pullInvoiceMessage, isPending: isPullingInvoiceMessage } =
    useMutationCheckMessage()
  const [findHistoryModalShow, setFindHistoryModalShow] = useState({
    show: false,
    objectId: null,
    createDate: null,
  })

  const [updateNumberFormat, setUpdateNumberFormat] = useState({
    show: false,
    objectId: null,
  })

  const [showEditUpdateSendTaxStatus, setShowEditUpdateSendTaxStatus] =
    useState({
      show: false,
    })

  return (
    <>
      {row.classify == INVOICE_CLASSIFY.MTT &&
        row.sendTaxStatus == SEND_TAX_STATUS.INVOICE_INVALID && (
          <TableAction
            titleActionText="Cập nhật hóa đơn hợp lệ và gửi message queue"
            icon={<CheckSquareFilled />}
            onClick={() => {
              console.log('row', row)
              setShowEditUpdateSendTaxStatus({ show: true, data: row })
            }}
          />
        )}

      <TableAction
        titleActionText="Cập nhật cấu hình thập phân"
        icon={<NumberOutlined />}
        onClick={() => {
          console.log('row', row)
          setUpdateNumberFormat({
            show: true,
            objectId: row?.invoiceId,
            companyId: row?.companyId,
            numberFormat: row?.numberFormat,
          })
        }}
      />
      {([INVOICE_STATUS.WAITING_FOR_AUTHORITY].includes(row.issueStatus) ||
        [SUMMARY_INVOICE_STATUS.WAITING_FOR_AUTHORITY].includes(
          row.sendTaxStatus,
        )) &&
      row.type !== INVOICE_TYPE.DELETED ? (
        <>
          <TableAction
            titleActionText="Kéo mã cho hóa đơn này"
            icon={
              <IconAction
                className={`${Utils.cn('far fa-rotate', isPullingInvoiceMessage && 'fa-spin')}`}
              />
            }
            onClick={() => {
              setTvanState({ key: 'activeRow', value: row })
              pullInvoiceMessage(row.messageId)
            }}
          />
        </>
      ) : null}
      {row.type !== INVOICE_TYPE.DELETED && (
        <TableAction
          titleActionText="Chuyển hóa đơn về gửi lỗi"
          icon={<IconAction className="fa-solid fa-turn-down-right" />}
          onClick={() => {
            setTvanState({ key: 'activeRow', value: row })
            setModalsState({ key: 'moveStatusModal', value: true })
          }}
        />
      )}
      <TableAction
        titleActionText="Lịch sử"
        icon={<IconAction className="fa-solid fa-clock-rotate-left" />}
        onClick={() => {
          setFindHistoryModalShow({
            show: true,
            objectId: `{"table":"invoices","key":"${row?.invoiceId}"}`,
            createDate: row?.date,
          })
        }}
      />
      {([SUMMARY_INVOICE_STATUS.INVOICE_INVALID].includes(row.sendTaxStatus) || // hóa đơn từ máy tính tiền
        [
          // hóa đơn thường
          INVOICE_STATUS.AUTHORITY_CODE_NOT_GIVEN,
          INVOICE_STATUS.AUTHORITY_DENY,
          INVOICE_STATUS.WAITING_FOR_AUTHORITY,
        ].includes(row.issueStatus)) &&
      row.type !== INVOICE_TYPE.DELETED ? (
        <TableAction
          titleActionText="Cập nhật mã thông điệp"
          icon={<IconAction className="fa-sharp-duotone fa-light fa-pen" />}
          onClick={() => {
            setTvanState({ key: 'activeRow', value: row })
            // pullInvoiceMessage(row.messageId)
            setModalsState({ key: 'updateMessageModal', value: true })
          }}
        />
      ) : null}
      <FindHistoryModal
        show={findHistoryModalShow?.show}
        onHide={() => setFindHistoryModalShow({ show: false })}
        title="Lịch sử đối tượng"
        objectId={findHistoryModalShow?.objectId}
        createDateObject={findHistoryModalShow?.createDate}
        // invoiceType={INVOICE_TYPE_TO_QUERY.CAN_ERR_ANNOUCED}
        buttonAgreeOnlick={(selectedInvoices) => {
          setFindHistoryModalShow(false)
          // for (let i = 0; i < selectedInvoices.length; i++) {
          //   for (let j = 0; j < tableData.length; j++) {
          //     if (selectedInvoices[i].invoiceId === tableData[j].invoiceId) {
          //       ToastHelper.showError(
          //         `Hoá đơn kí hiệu ${selectedInvoices[i].serial}, số  ${selectedInvoices[i].no} đã được chọn`,
          //       )
          //       return
          //     }
          //   }
          // }
          // const newTableData = [...tableData, ...selectedInvoices]
          // newTableData.map((invoice, index) => {
          //   invoice.STT = index + 1
          //   // invoice.errAnnouceType = 1
          // })
          // setTableData(newTableData)
          setFindHistoryModalShow(false)
        }}
        buttonAgreeTab2Onlick={(selectedInvoice) => {
          // const newTableData = [...tableData, selectedInvoice]
          // newTableData.map((invoice, index) => {
          //   invoice.STT = index + 1
          // })
          // setTableData(newTableData)
          setFindHistoryModalShow(false)
        }}
        // buttonAgreeVisibility={true}
        // checkBoxShow={false}
        // selectableRows={true}
        onRowClicked={() => {}}
        showTab={false}
        defaultTab={0}
      />
      <ModalUpdateNumberFormat
        show={updateNumberFormat?.show}
        onHide={() => setUpdateNumberFormat({ show: false })}
        title="Thông tin cập nhật số thập phân"
        objectId={updateNumberFormat?.objectId}
        companyId={updateNumberFormat?.companyId}
        numberFormat={updateNumberFormat?.numberFormat}
      />

      <ModalUpdateSendTaxStatus
        modalsState={showEditUpdateSendTaxStatus}
        setModalsState={(value) => {
          setShowEditUpdateSendTaxStatus(value)
        }}
        refetchList={() => {
          refetchListInvoice()
        }}
      />
    </>
  )
}
